import { useState, useEffect, useRef } from 'react'
import { withRouter } from '../utils'
import axios from 'axios'

const GOLD = '#C29717'
const ORANGE = '#E8912A'
const DISPLAY = { fontFamily: '"Gruppo", sans-serif' }
const BODY = 'Montserrat, "Segoe UI", sans-serif'
const Ball = ({ mt = 0, size = 7 }) => <span style={{ width: size, height: size, borderRadius: '50%', background: GOLD, display: 'inline-block', flexShrink: 0, marginTop: mt }} />
const BLOCKS = [
  { key: 'Syria', label: 'Syria' },
  { key: 'Lebanon', label: 'Lebanon' },
  { key: 'GCC', label: 'GCC', sub: 'Saudi Arabia · UAE · Kuwait · Bahrain · Qatar · Oman' }
]

function FreeTrial({ navigate }) {
  const apiHost = process.env.REACT_APP_APIHOST || 'http://localhost:3033'
  const token = localStorage.getItem('token')
  if (token) {
    const DailyReports = require('./DailyReports').default
    return <DailyReports navigate={navigate} />
  }
  return <TrialLanding apiHost={apiHost} navigate={navigate} />
}

const SLIDES = [
  { img: 'icons/sc2.png', icon: 'icons/icons/slide-2.svg', title: 'Intelligence Feed', desc: 'Get access to a real-time event stream with conflict classification, severity tagging and casualty breakdowns, plus expandable incident details with geolocation, source attribution and mapping. Filter by country, violence type and date range.' },
  { img: 'icons/sc8.png', icon: 'icons/icons/slide-3.svg', title: 'Daily Incidents & Threat Analytics', desc: 'Discover event-frequency charts with casualty overlay, cumulative threat-level tracking and multi-tab analytics across Events, Casualties, Threat Level and Timeline, with a major-events panel highlighting critical developments.' },
  { img: 'icons/sc7.png', icon: 'icons/icons/slide-4.svg', title: 'Intelligence & Forecast Reports', desc: 'Get access to analyst-grade reports combining incident overviews, strategic implications and escalation context, cross-referencing actors, supply chains and geopolitics. Exportable and shareable across your organization.' },
  { img: 'icons/sc6.png', icon: 'icons/icons/slide-5.svg', title: 'Threat Score & Impact Zones', desc: 'Discover country-level threat scoring on a 1-10 scale with target mapping across cities and strategic assets, each assessed for attack probability from historical patterns and current escalation.' },
  { img: 'icons/sc5.png', icon: 'icons/icons/slide-6.svg', title: 'Satellite Damage Assessment', desc: 'Get access to post-strike satellite imagery with thermal detection, before/after comparison and damage classification within hours, plus a consolidated impact summary and GEOINT analyst read.' },
  { img: 'icons/sc3.png', icon: 'icons/icons/slide-7.svg', title: 'Evacuation Protocols', desc: 'Discover pre-planned extraction routes with safe-haven identification, live airport status and multi-route alternatives, factoring in airspace disruptions, embassy proximity and hospital locations.' },
  { img: 'icons/sc4.png', icon: 'icons/icons/slide-8.svg', title: 'Personnel Alerting', desc: 'Get access to live personnel tracking with SOS triggers, automated zone warnings and check-ins, plus instant SMS and Telegram alerts when your team enters high-risk areas.' },
  { img: 'icons/sc10.png', icon: 'icons/icons/slide-9.svg', title: 'Weapons Deployment Timeline', desc: 'Discover weapon-system deployment over time with escalation-ladder indicators, correlating usage with conflict phases to forecast next-stage escalation risks.' },
  { img: 'icons/sc9.png', icon: 'icons/icons/slide-10.svg', title: 'Arsenal Database', desc: 'Get access to a catalog of offensive and defensive military systems with specifications, operator-country mapping and confirmed deployment counts, cross-referenced with active conflict data.' }
]

function FeatureSlider() {
  const [i, setI] = useState(0)
  const paused = useRef(false)
  useEffect(() => {
    const t = setInterval(() => { if (!paused.current) setI(p => (p + 1) % SLIDES.length) }, 4200)
    return () => clearInterval(t)
  }, [])
  const s = SLIDES[i]
  return (
    <div onMouseEnter={() => (paused.current = true)} onMouseLeave={() => (paused.current = false)}
      style={{ position: 'relative', borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)', boxShadow: '0 20px 60px rgba(0,0,0,0.55)', background: '#0b0b0c' }}>
      <img src={'/' + s.img} alt={s.title} style={{ width: '100%', display: 'block', aspectRatio: '16/10', objectFit: 'cover' }} />
      {/* caption */}
      <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, padding: '30px 18px 14px', background: 'linear-gradient(180deg,transparent,rgba(6,6,7,0.92))' }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: '#fff' }}>{s.title}</div>
        <div style={{ fontSize: 11.5, color: '#b6bcc4', lineHeight: 1.5, marginTop: 3 }}>{s.desc}</div>
      </div>
      {/* arrows */}
      <Arrow left onClick={() => setI(p => (p - 1 + SLIDES.length) % SLIDES.length)} />
      <Arrow onClick={() => setI(p => (p + 1) % SLIDES.length)} />
      {/* indicators */}
      <div style={{ position: 'absolute', top: 12, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 5 }}>
        {SLIDES.map((_, k) => <span key={k} onClick={() => setI(k)} style={{ width: k === i ? 16 : 6, height: 6, borderRadius: 3, background: k === i ? GOLD : 'rgba(255,255,255,0.3)', cursor: 'pointer', transition: 'all .25s' }} />)}
      </div>
    </div>
  )
}
const Arrow = ({ left, onClick }) => (
  <div onClick={onClick} style={{ position: 'absolute', [left ? 'left' : 'right']: 10, top: '46%', width: 30, height: 30, borderRadius: '50%', background: 'rgba(0,0,0,0.55)', border: '1px solid rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#ddd', fontSize: 15, userSelect: 'none' }}>{left ? '‹' : '›'}</div>
)

// Phone frame (notch + status bar). Screen content is passed as children.
function PhoneMock({ children }) {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div style={{ position: 'absolute', left: -2, top: 96, width: 3, height: 28, background: '#0c0c0d', borderRadius: 3 }} />
      <div style={{ position: 'absolute', left: -2, top: 138, width: 3, height: 52, background: '#0c0c0d', borderRadius: 3 }} />
      <div style={{ position: 'absolute', right: -2, top: 128, width: 3, height: 78, background: '#0c0c0d', borderRadius: 3 }} />
      <div style={{ background: 'linear-gradient(150deg,#3a3a3d,#0d0d0f 55%)', borderRadius: 44, padding: 10, boxShadow: '0 40px 90px rgba(0,0,0,0.6), inset 0 0 1px rgba(255,255,255,0.35)' }}>
        <div style={{ position: 'relative', borderRadius: 34, overflow: 'hidden', background: '#17212b' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 20px 7px', background: '#17212b', color: '#fff', fontSize: 12.5, fontFamily: BODY, position: 'relative', zIndex: 2 }}>
            <span style={{ fontWeight: 600, letterSpacing: 0.2 }}>21:42</span>
            <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
              <svg width="17" height="11" viewBox="0 0 17 11" fill="#fff"><rect x="0" y="7" width="3" height="4" rx="0.6" /><rect x="4.5" y="5" width="3" height="6" rx="0.6" /><rect x="9" y="2.5" width="3" height="8.5" rx="0.6" /><rect x="13.5" y="0" width="3" height="11" rx="0.6" /></svg>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="#fff"><path d="M8 2.2c2.5 0 4.8 1 6.4 2.6l-1.2 1.2C11.9 4.7 10 3.9 8 3.9s-3.9.8-5.2 2.1L1.6 4.8C3.2 3.2 5.5 2.2 8 2.2z" /><path d="M8 5.5c1.4 0 2.7.6 3.6 1.5l-1.2 1.2c-.6-.6-1.5-1-2.4-1s-1.8.4-2.4 1L4.4 7c.9-.9 2.2-1.5 3.6-1.5z" /><circle cx="8" cy="9.6" r="1.3" /></svg>
              <svg width="25" height="12" viewBox="0 0 25 12" fill="none"><rect x="1" y="1" width="21" height="10" rx="2.6" stroke="#fff" strokeOpacity="0.55" /><rect x="2.6" y="2.6" width="16" height="6.8" rx="1.2" fill="#fff" /><rect x="23" y="4" width="1.6" height="4" rx="0.8" fill="#fff" fillOpacity="0.55" /></svg>
            </span>
          </div>
          <div style={{ position: 'absolute', top: 9, left: '50%', transform: 'translateX(-50%)', width: 84, height: 20, background: '#000', borderRadius: 12, zIndex: 3 }} />
          {children}
        </div>
      </div>
    </div>
  )
}

// ---- Reconstructed Telegram feed (real content), auto-rotating slider ----
const TG = { bg: '#0e1621', bubble: '#182533', text: '#dfe6ee', title: '#fff', meta: '#8aa0b4', link: '#65b3f0', time: '#6d8299' }
function Bub({ children, style }) {
  return <div style={{ maxWidth: '95%', background: TG.bubble, borderRadius: '7px 14px 14px 14px', overflow: 'hidden', boxShadow: '0 1px 1px rgba(0,0,0,0.25)', ...style }}>{children}</div>
}
function Evt({ country, title, time, date, desc, coords }) {
  return (
    <div style={{ padding: '8px 11px 9px' }}>
      <div style={{ fontSize: 12.5, fontWeight: 700, color: TG.title }}>{country}</div>
      <div style={{ fontSize: 12.5, color: TG.text, fontWeight: 600, margin: '1px 0 5px' }}>{title} <span style={{ color: TG.meta, fontWeight: 400 }}>({date})</span></div>
      <div style={{ fontSize: 11.5, color: TG.text, lineHeight: 1.5 }}>{desc}</div>
      {coords && <div style={{ fontSize: 10.5, color: TG.meta, marginTop: 6, lineHeight: 1.5 }}>Geo-coordinates: {coords}</div>}
      <div style={{ textAlign: 'right', fontSize: 9.5, color: TG.time, marginTop: 4 }}>{time}</div>
    </div>
  )
}
const TG_SLIDES = [
  // 1 — Syria event with map + photo
  (
    <Bub>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <img src="/icons/s1map.png" alt="" style={{ width: '100%', height: 104, objectFit: 'cover', display: 'block' }} />
        <img src="/uploads/1784901925530-200384596.png" alt="" style={{ width: '100%', height: 104, objectFit: 'cover', display: 'block' }} />
      </div>
      <Evt country="Syria" title="Security raid" date="17:04" time="17:04"
        desc="Security forces launched an arrest campaign targeting criminals and drug dealers across southern Damascus, including Babila, Beit Sahem, Set Zainab and Yalda."
        coords="Babella · Beit Sahm · Yalda · As-Sayyida Zeinab" />
    </Bub>
  ),
  // 2 — GCC events feed
  (
    <>
      <Bub style={{ marginBottom: 7 }}>
        <img src="/icons/s3map.png" alt="" style={{ width: '100%', display: 'block' }} />
        <Evt country="Kuwait" title="Iranian drone attack" date="17:25" time="17:25"
          desc="Sirens and air-defence systems activated across Kuwait amid an ongoing Iranian drone attack."
          coords="Mubarak Al Mayal St (29.3396, 47.7473)" />
      </Bub>
      <Bub style={{ marginBottom: 7 }}>
        <Evt country="Bahrain" title="Air-defence activation" date="13:10" time="13:10"
          desc="Air-defence systems activated across Bahrain amid an ongoing Iranian missile and drone attack." />
      </Bub>
      <Bub>
        <Evt country="Saudi Arabia" title="Warehouse fire, Medina" date="15:31" time="15:31"
          desc="A large fire erupted inside a warehouse in Medina, amid reports of a hostile drone infiltration in the area." />
      </Bub>
    </>
  ),
  // 4 — Intelligence report
  (
    <Bub>
      <img src="/icons/phone-map.png" alt="" style={{ width: '100%', display: 'block' }} />
      <div style={{ padding: '8px 11px 9px' }}>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: TG.title, lineHeight: 1.3 }}>Intel Brief | The postponed strike, the modified proposal, and the escalation threshold</div>
        <div style={{ fontSize: 11, color: TG.meta, fontStyle: 'italic', margin: '3px 0 6px' }}>UAE, Kuwait, Bahrain, Oman · 24 Jul</div>
        <div style={{ fontSize: 11.5, color: TG.text, lineHeight: 1.5 }}>The latest attempt to halt the Iran-US confrontation has failed. Iraqi PM Ali al-Zaidi, acting as mediator after his White House meeting, put a US-backed ceasefire proposal to Tehran. It was turned down over control of the Strait of Hormuz.</div>
        <div style={{ textAlign: 'right', fontSize: 9.5, color: TG.time, marginTop: 4 }}>13:46</div>
      </div>
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)', textAlign: 'center', padding: '9px', color: TG.link, fontSize: 12, fontWeight: 500 }}>Read the full report</div>
    </Bub>
  ),
]
// A single Telegram thread of all content that slowly auto-scrolls to showcase it.
// Vague-but-realistic emergency push alerts that pop in during the scroll.
const NOTIFS = [
  { body: 'Large explosion reported, 2 casualties confirmed. Sirens now active along the north-east coast.' },
  { body: 'Air-defence activated against an incoming aerial threat. Shelter-in-place advised across the district.' },
  { body: 'Drone strike on an energy facility, fire ongoing. Main roads closed on the southern approach.' },
]
function PhoneFeed() {
  const [notif, setNotif] = useState(null)
  useEffect(() => {
    let i = 0, alive = true, t1, t2, t3
    const run = () => {
      if (!alive) return
      setNotif({ ...NOTIFS[i % NOTIFS.length], hiding: false })
      t1 = setTimeout(() => alive && setNotif(n => (n ? { ...n, hiding: true } : n)), 2300)
      t2 = setTimeout(() => alive && setNotif(null), 2650)
      i++
      t3 = setTimeout(run, 9800)
    }
    const t0 = setTimeout(run, 2600)
    return () => { alive = false;[t0, t1, t2, t3].forEach(clearTimeout) }
  }, [])
  return (
    <div style={{ background: TG.bg, height: 620, overflow: 'hidden', position: 'relative' }}>
      {/* pinned chat header */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 4, display: 'flex', alignItems: 'center', gap: 9, padding: '7px 12px', background: '#17212b', borderBottom: '1px solid rgba(0,0,0,0.3)' }}>
        <span style={{ color: '#5b6b7a', fontSize: 19 }}>‹</span>
        <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'linear-gradient(135deg,#d9ab2e,#8a6a12)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1a1a1a', fontSize: 12, fontWeight: 800 }}>F</div>
        <div style={{ lineHeight: 1.25 }}>
          <div style={{ fontSize: 12.5, color: '#fff', fontWeight: 600 }}>FORTE Intel</div>
          <div style={{ fontSize: 10.5, color: TG.link }}>@forteintelbot</div>
        </div>
      </div>
      {/* auto-scrolling thread */}
      <div style={{ paddingTop: 46, animation: 'tgscroll 44s ease-in-out infinite alternate' }}>
        <div style={{ padding: '10px 9px 24px', display: 'flex', flexDirection: 'column', gap: 9 }}>
          <div style={{ textAlign: 'center', margin: '0 0 2px' }}>
            <span style={{ fontSize: 10, color: TG.meta, background: 'rgba(255,255,255,0.06)', borderRadius: 10, padding: '2px 10px' }}>Today</span>
          </div>
          {TG_SLIDES.map((s, k) => <div key={k}>{s}</div>)}
        </div>
      </div>
      {/* live push notification (heads-up) */}
      {notif && (
        <div style={{ position: 'absolute', top: 7, left: 8, right: 8, zIndex: 30, background: 'rgba(30,39,50,0.95)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)', borderRadius: 15, padding: '9px 11px', boxShadow: '0 12px 30px rgba(0,0,0,0.55)', border: '1px solid rgba(255,255,255,0.09)', display: 'flex', gap: 9, animation: notif.hiding ? 'tgnotifOut .3s ease forwards' : 'tgnotif .4s cubic-bezier(.2,.9,.2,1)' }}>
          <div style={{ width: 30, height: 30, borderRadius: 8, background: 'linear-gradient(135deg,#d9ab2e,#8a6a12)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1a1a1a', fontSize: 13, fontWeight: 800, flexShrink: 0 }}>F</div>
          <div style={{ minWidth: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 6 }}>
              <span style={{ fontSize: 11.5, fontWeight: 600, color: '#fff' }}>FORTE Intel</span>
              <span style={{ fontSize: 9.5, color: '#9aa4ad', flexShrink: 0 }}>now</span>
            </div>
            <div style={{ fontSize: 11, color: '#e6ebf0', lineHeight: 1.42, marginTop: 1 }}>{notif.body}</div>
          </div>
        </div>
      )}
    </div>
  )
}

// Platform showcase — same style/positioning as the homepage "info" slider.
function PlatformDemo() {
  const [i, setI] = useState(0)
  const paused = useRef(false)
  useEffect(() => { const t = setInterval(() => { if (!paused.current) setI(p => (p + 1) % SLIDES.length) }, 4200); return () => clearInterval(t) }, [])
  const s = SLIDES[i]
  const arrow = { position: 'absolute', top: '50%', transform: 'translateY(-50%)', width: 32, height: 32, borderRadius: '50%', background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#aaa', fontSize: 15, userSelect: 'none' }
  return (
    <div style={{ maxWidth: 1000, margin: '0 auto' }} onMouseEnter={() => (paused.current = true)} onMouseLeave={() => (paused.current = false)}>
      {/* screenshot with arrows */}
      <div style={{ position: 'relative', marginBottom: 22 }}>
        <img key={i} src={'/' + s.img} alt={s.title} onLoad={() => window.dispatchEvent(new Event('resize'))} style={{ width: '100%', display: 'block', borderRadius: 6, border: '1px solid rgba(255,255,255,0.08)', boxShadow: '0 24px 70px rgba(0,0,0,0.5)', animation: 'tgfade .5s ease' }} />
        <div onClick={() => setI(p => p === 0 ? SLIDES.length - 1 : p - 1)} style={{ ...arrow, left: 12 }}>&#8249;</div>
        <div onClick={() => setI(p => (p + 1) % SLIDES.length)} style={{ ...arrow, right: 12 }}>&#8250;</div>
      </div>
      {/* text with left separator (like HP) */}
      <div style={{ paddingLeft: 16, borderLeft: '0.5px solid rgba(255,255,255,0.3)', maxWidth: 760 }}>
        <div style={{ display: 'flex', gap: 3, marginBottom: 16, alignItems: 'center', flexWrap: 'wrap' }}>
          {SLIDES.map((sl, k) => (
            <div key={k} onClick={() => setI(k)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 22, borderRadius: 3, cursor: 'pointer', transition: 'all .3s', background: k === i ? 'rgba(194,151,23,0.14)' : 'transparent', borderBottom: k === i ? '2px solid #C29717' : '2px solid rgba(255,255,255,0.06)' }}>
              {sl.icon && <img src={'/' + sl.icon} alt="" style={{ width: 14, height: 11, filter: 'brightness(0) invert(0.85)', opacity: k === i ? 1 : 0.4 }} />}
            </div>
          ))}
        </div>
        <div style={{ fontSize: 10, color: '#C29717', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 8 }}>{s.title}</div>
        <p style={{ fontSize: 14, lineHeight: 1.7, color: '#c3c3c3', margin: 0, fontFamily: BODY }}>{s.desc}</p>
      </div>
    </div>
  )
}

function TrialLanding({ apiHost, navigate }) {
  const [open, setOpen] = useState(false)
  const [pricingOpen, setPricingOpen] = useState(false)
  useEffect(() => {
    document.body.style.background = '#292929'
    // This page grows as images/phone load, but <html> is fixed at 100vh so the
    // global Lenis smooth-scroll never recomputes its limit (mouse wheel dies while
    // keyboard still works). Firing resize makes Lenis re-measure and scroll again.
    const wake = () => window.dispatchEvent(new Event('resize'))
    const timers = [0, 300, 900, 1800, 3200].map(d => setTimeout(wake, d))
    return () => { document.body.style.background = ''; timers.forEach(clearTimeout) }
  }, [])

  return (
    <>
    <div style={{ position: 'relative', minHeight: '100vh', color: '#fff', background: '#292929', fontFamily: BODY, overflow: 'hidden' }}>
      <style>{`@keyframes ftspin{to{transform:rotate(360deg)}}@keyframes tgscroll{0%,7%{transform:translateY(0)}93%,100%{transform:translateY(-800px)}}@keyframes tgnotif{from{transform:translateY(-130%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes tgnotifOut{from{transform:translateY(0);opacity:1}to{transform:translateY(-130%);opacity:0}}`}</style>
      {/* atmospheric background (like homepage) */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
        <img src="/icons/bg-1.webp" alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.14 }} />
        <img src="/icons/shape-1.webp" alt="" style={{ position: 'absolute', top: 10, left: -70, width: 900, maxWidth: '74%', transform: 'rotate(-9deg)', opacity: 0.7 }} />
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(1000px 520px at 84% 0%, rgba(194,151,23,0.09), transparent 60%)' }} />
      </div>

      <div style={{ position: 'relative', zIndex: 1 }}>
      {/* Header — logo + homepage-style separator underneath */}
      <div style={{ maxWidth: 1160, margin: '0 auto', padding: '0 28px' }}>
        <div style={{ padding: '18px 0 6px', display: 'flex', alignItems: 'center' }}>
          <a href="/"><img src="/icons/logo.webp" alt="FORTE" style={{ height: 28, opacity: 0.95 }} /></a>
        </div>
      </div>

      {/* Hero: text + phone (phone is cut off at the bottom separator) */}
      <div style={{ maxWidth: 1160, margin: '0 auto', padding: '0 28px 0', display: 'grid', gridTemplateColumns: 'minmax(300px,1fr) minmax(330px,1.05fr)', gap: 44, alignItems: 'center', position: 'relative', borderBottom: '0.5px solid rgba(255,255,255,0.2)', minHeight: 512 }} className="ft-hero">
        <div>
          <div style={{ marginBottom: 18, marginTop: 6 }}>
            <h1 style={{ ...DISPLAY, fontSize: 33, fontWeight: 400, lineHeight: 1.2, margin: 0 }}>Live conflict intelligence, delivered to your <img src="/icons/telegram.png" alt="" style={{ width: 23, height: 23, borderRadius: 4, verticalAlign: 'middle', position: 'relative', top: -1, margin: '0 5px 0 0' }} /><span style={{ color: '#4bb4f5' }}>Telegram</span>.</h1>
          </div>
          <div style={{ borderLeft: '0.5px solid rgba(255,255,255,0.3)', paddingLeft: 22, margin: '0 0 20px', maxWidth: 500 }}>
            <p style={{ fontSize: 13.5, color: '#c3c3c3', lineHeight: 1.75, margin: 0 }}>
              FORTE tracks incidents and emerging threats across contested, high-uncertainty regions, collected and verified by human intelligence analysts on the ground and reported as they develop.
              <br /><br />
              Every alert carries the assessment behind it: what occurred, what it indicates, and how the situation is likely to shift. Actionable intelligence, ahead of open sources.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap', marginBottom: 14 }}>
            <button onClick={() => setOpen(true)} style={{ background: GOLD, color: '#1a1a1a', border: 'none', borderRadius: 5, padding: '13px 28px', fontSize: 13.5, fontWeight: 700, cursor: 'pointer', letterSpacing: 0.4 }}>Get free access to FORTE Intel (15 days)</button>
          </div>
          <div style={{ display: 'flex', gap: 18, fontSize: 11.5, color: '#9a9a9a', flexWrap: 'wrap', alignItems: 'center', paddingTop: 10 }}>
            {['15 days free', 'No card required', 'Setup in 2 minutes'].map(t => <span key={t} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><span style={{ color: '#C29717', fontWeight: 700 }}>·</span>{t}</span>)}
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><span style={{ color: '#C29717', fontWeight: 700 }}>·</span>then from <b style={{ color: '#d8d8d8', fontWeight: 700, margin: '0 1px' }}>$99/mo</b> · <span onClick={() => setPricingOpen(true)} style={{ color: '#C29717', cursor: 'pointer', borderBottom: '1px solid rgba(194,151,23,0.4)', marginLeft: 3 }}>see pricing</span></span>
          </div>
        </div>
        <div className="ft-phone-cell" style={{ position: 'relative', alignSelf: 'stretch' }}>
          {/* phone: clipped only at the bottom (its own overflow), rises OVER the header via z-index */}
          <div className="ft-phone-wrap" style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: 300, height: 541, overflow: 'hidden', borderRadius: '44px 44px 0 0', zIndex: 20 }}>
            <PhoneMock><PhoneFeed /></PhoneMock>
          </div>
        </div>
      </div>

      {/* Platform demo */}
      <div style={{ maxWidth: 1160, margin: '0 auto', padding: '42px 28px 44px' }}>
        <PlatformDemo />
      </div>

      {/* Analyst credibility band — ground-truth / HUMINT (moved under the platform demo) */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', borderBottom: '1px solid rgba(255,255,255,0.06)', background: 'rgba(255,255,255,0.015)' }}>
        <div style={{ maxWidth: 1160, margin: '0 auto', padding: '30px 28px', display: 'grid', gridTemplateColumns: 'minmax(0,0.62fr) minmax(0,1.38fr)', gap: 30, alignItems: 'center' }} className="ft-gt">
          <div style={{ borderRadius: 6, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.06)' }}>
            <img src="/icons/ground-truth.jpg?v=3" alt="FORTE GSOC analysts monitoring live intelligence" style={{ width: '100%', display: 'block', opacity: 0.9 }} />
          </div>
          <div>
            <div style={{ ...DISPLAY, fontSize: 17, letterSpacing: 2, textTransform: 'uppercase', color: '#fff', marginBottom: 5 }}>Ground-truth intelligence</div>
            <div style={{ fontFamily: 'ui-monospace, Menlo, monospace', fontSize: 10, letterSpacing: 2, color: '#C29717', textTransform: 'uppercase', marginBottom: 11 }}>// HUMINT · Local analysts · In-theatre</div>
            <p style={{ margin: 0, fontSize: 13.5, color: '#b0b0b0', lineHeight: 1.7, fontFamily: BODY }}>
              Every event is reported and assessed by <b style={{ color: '#e6e6e6' }}>local intelligence and risk analysts</b> based in the region. They know the context, the actors and how situations tend to develop, so the intelligence you receive is checked by people who understand it firsthand.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ position: 'relative', background: '#242424', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', bottom: -20, right: 0, width: 340, maxWidth: '38%', pointerEvents: 'none', opacity: 0.32 }}>
          <img src="/icons/shape-3.webp" alt="" style={{ width: '100%' }} />
        </div>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '26px 28px', position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 22, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <img src="/icons/logo.webp" alt="FORTE" style={{ height: 22, opacity: 0.9 }} />
            <span style={{ ...DISPLAY, fontSize: 12, color: '#7d7d7d', letterSpacing: 1 }}>FORTE INTEL | 2026</span>
          </div>
        </div>
      </footer>
      </div>
    </div>
    <style>{`@media(max-width:820px){.ft-hero{grid-template-columns:1fr !important;min-height:auto !important;padding-bottom:0 !important}.ft-gt{grid-template-columns:1fr !important}.ft-phone-cell{align-self:auto !important;height:auto !important}.ft-phone-wrap{position:relative !important;inset:auto !important;transform:none !important;width:290px !important;height:auto !important;max-height:none !important;overflow:visible !important;margin:10px auto 30px !important;z-index:1 !important}}@media(max-width:680px){.ft-plandiv{display:none !important}}@media(max-width:460px){.ft-step2{flex-direction:column !important}}`}</style>
    {open && <Wizard apiHost={apiHost} navigate={navigate} close={() => setOpen(false)} />}
    {pricingOpen && <PricingModal onClose={() => setPricingOpen(false)} onStart={() => { setPricingOpen(false); setOpen(true) }} />}
    </>
  )
}

// ================= PRICING POPUP =================
function PricingModal({ onClose, onStart }) {
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.72)', backdropFilter: 'blur(4px)', zIndex: 100000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '40px 16px' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 780, maxWidth: '100%', background: '#2c2c31', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 7, boxShadow: '0 20px 70px rgba(0,0,0,0.6)', fontFamily: BODY, position: 'relative', overflow: 'hidden' }}>
        <button onClick={onClose} aria-label="Close" style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 24, color: '#c4c4c4', cursor: 'pointer', lineHeight: 1, zIndex: 3 }}>&times;</button>
        <div style={{ padding: '40px 34px 34px' }}>
          <div style={{ textAlign: 'center', marginBottom: 34 }}>
            <h2 style={{ ...DISPLAY, fontSize: 21, fontWeight: 400, textTransform: 'uppercase', letterSpacing: 2, margin: '0 0 9px', color: '#fff' }}>Pricing</h2>
            <p style={{ fontSize: 12.5, color: '#d6dbe1', margin: 0, lineHeight: 1.6 }}>Free for 15 days, then priced per country. Cancel anytime.</p>
          </div>
          <div style={{ maxWidth: 720, margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'stretch' }}>
              <PlanCard price="99" tagline="Essential" points={['Access to the FORTE Intelligence platform (live map, events, analytics)', 'Real-time incident Telegram alerts', 'Monthly intelligence reports', 'Flash situational updates']} />
              <div className="ft-plandiv" style={{ width: 1, background: 'rgba(255,255,255,0.08)', alignSelf: 'stretch', margin: '4px 0' }} />
              <PlanCard price="239" featured tagline="Complete" points={['Everything in Essential', 'Weekly intelligence reports with risk assessments and forecasts', 'Direct email PDF reports', 'Live localized monitoring and alerts (SMS, app), 5 employees included per country']} />
            </div>
            {/* Add-on */}
            <div style={{ marginTop: 30, paddingTop: 26, borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 240 }}>
                <div style={{ ...DISPLAY, fontSize: 14, color: '#f4f4f4', textTransform: 'uppercase', letterSpacing: 1.5, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  Employee alerting
                  <span style={{ fontFamily: BODY, fontSize: 9.5, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase', color: '#a2a2a2', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 3, padding: '2px 8px' }}>5 employees free</span>
                </div>
                <div style={{ fontFamily: BODY, fontSize: 12.5, color: '#d6dbe1', lineHeight: 1.55, marginTop: 7 }}>SOS triggers, zone warnings and live field tracking for your personnel on the ground.</div>
              </div>
              <div style={{ whiteSpace: 'nowrap', fontFamily: BODY, textAlign: 'right' }}>
                <span style={{ fontSize: 22, fontWeight: 500, color: '#fff' }}>$19</span>
                <span style={{ fontSize: 12, color: '#7e838a' }}> / employee</span>
              </div>
            </div>
          </div>
          <div style={{ textAlign: 'center', marginTop: 32 }}>
            <button onClick={onStart} style={{ background: GOLD, color: '#1a1a1a', border: 'none', borderRadius: 5, padding: '13px 32px', fontSize: 13, fontWeight: 700, cursor: 'pointer', letterSpacing: 0.4 }}>Start your free trial</button>
          </div>
        </div>
      </div>
    </div>
  )
}

function PlanCard({ price, points, featured, tagline }) {
  return (
    <div style={{ flex: '1 1 300px', maxWidth: 320, padding: '2px 34px' }}>
      <div style={{ ...DISPLAY, fontSize: 12.5, color: featured ? GOLD : '#a2a2a2', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 16 }}>
        {tagline}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 3 }}>
        <span style={{ fontFamily: BODY, fontSize: 32, fontWeight: 500, color: '#fff', letterSpacing: -0.5 }}>${price}</span>
        <span style={{ fontFamily: BODY, fontSize: 12.5, color: '#7e838a' }}>/ month · per country</span>
      </div>
      <div style={{ height: 1, background: 'rgba(255,255,255,0.08)', margin: '18px 0' }} />
      {points.map((p, i) => (
        <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 12, fontSize: 13, color: '#bdbdbd', fontFamily: BODY, lineHeight: 1.45 }}>
          <span style={{ color: '#5f6470', marginTop: 1, flexShrink: 0 }}>›</span><span>{p}</span>
        </div>
      ))}
    </div>
  )
}

// ================= WIZARD =================
function Wizard({ apiHost, navigate, close }) {
  const [step, setStep] = useState(1)
  const [signupId, setSignupId] = useState(null)
  const [form, setForm] = useState({ telegramUsername: '', phone: '', name: '', email: '' })
  const [blocks, setBlocks] = useState([])
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [checkMsg, setCheckMsg] = useState('')
  const [checking, setChecking] = useState(false)
  const [activeCountries, setActiveCountries] = useState([])
  const [wantAccess, setWantAccess] = useState(null)
  const [password, setPassword] = useState('')
  const [doneEmail, setDoneEmail] = useState('')
  const retryRef = useRef(null)

  useEffect(() => () => { if (retryRef.current) clearTimeout(retryRef.current) }, [])

  const toggleBlock = k => setBlocks(b => b.includes(k) ? b.filter(x => x !== k) : [...b, k])

  const submitStep1 = async () => {
    setErr('')
    const tg = form.telegramUsername.trim().replace(/^@/, '')
    const ph = (form.phone || '').trim()
    if ((!tg && !ph) || !form.name.trim()) return setErr('Enter your Telegram username or phone number, plus your name.')
    if (!blocks.length) return setErr('Select at least one region of interest.')
    setBusy(true)
    try {
      const res = await axios.post(apiHost + '/free-trial/signup', { telegramUsername: tg, phone: ph, name: form.name, countries: blocks })
      setSignupId(res.data.data.id); setStep(2)
    } catch (e) { setErr(e.response?.data?.errorMessage || 'Something went wrong. Try again.') }
    setBusy(false)
  }

  const checkBot = () => {
    setErr(''); setChecking(true); setCheckMsg('Checking Telegram…')
    const deadline = Date.now() + 45000
    const attempt = async () => {
      try {
        const res = await axios.post(apiHost + '/free-trial/check-bot', { id: signupId })
        if (res.data.added) { setActiveCountries(res.data.countries || []); setChecking(false); setStep(3); return }
      } catch (e) {}
      if (Date.now() < deadline) { setCheckMsg('Not detected yet, give it a few seconds.'); retryRef.current = setTimeout(attempt, 4000) }
      else { setChecking(false); setCheckMsg(''); setErr("We couldn't detect it. Make sure you tapped Start in the bot, then click below to check again.") }
    }
    attempt()
  }

  const createAccess = async () => {
    setErr('')
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((form.email || '').trim())) return setErr('Please enter a valid email address.')
    if (password.length < 6) return setErr('Password must be at least 6 characters.')
    setBusy(true)
    try {
      const res = await axios.post(apiHost + '/free-trial/create-access', { id: signupId, email: form.email.trim(), password })
      // no auto-login — the user must verify their email before entering the platform
      setDoneEmail(res.data.email)
      setWantAccess('done')
    } catch (e) { setErr(e.response?.data?.errorMessage || 'Could not create access.') }
    setBusy(false)
  }

  const inp = { width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 5, padding: '11px 13px', color: '#f4f4f4', fontSize: 13.5, outline: 'none', boxSizing: 'border-box' }
  const lbl = { fontSize: 10, color: '#d2d2d2', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 5, display: 'block' }

  return (
    <div onClick={close} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.72)', backdropFilter: 'blur(4px)', zIndex: 100000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '40px 16px' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 600, maxWidth: '100%', background: '#2c2c31', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 7, boxShadow: '0 20px 70px rgba(0,0,0,0.6)', fontFamily: 'Inter,sans-serif', overflow: 'hidden' }}>
        {/* progress — numbered 3-step stepper */}
        <div style={{ display: 'flex', alignItems: 'center', padding: '15px 18px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ display: 'flex', alignItems: 'center', flex: 1, marginRight: 12 }}>
            {[{ n: 1, l: 'Your details' }, { n: 2, l: 'Telegram' }, { n: 3, l: 'Access' }].map((s, i, arr) => {
              const done = step > s.n, active = step === s.n
              return (
                <div key={s.n} style={{ display: 'flex', alignItems: 'center', flex: i < arr.length - 1 ? 1 : 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ width: 22, height: 22, borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: BODY, fontSize: 11, fontWeight: 700, background: done || active ? GOLD : 'transparent', color: done || active ? '#1a1a1a' : '#8a8a8a', border: done || active ? 'none' : '1px solid rgba(255,255,255,0.2)', transition: 'all .2s' }}>
                      {done ? '✓' : s.n}
                    </span>
                    <span style={{ fontFamily: BODY, fontSize: 11.5, whiteSpace: 'nowrap', color: active ? '#fff' : done ? '#b8b8b8' : '#6f6f6f', fontWeight: active ? 600 : 400 }}>{s.l}</span>
                  </div>
                  {i < arr.length - 1 && <div style={{ flex: 1, height: 1, background: done ? GOLD : 'rgba(255,255,255,0.12)', margin: '0 10px', minWidth: 14 }} />}
                </div>
              )
            })}
          </div>
          <button onClick={close} style={{ background: 'none', border: 'none', color: '#c4c4c4', fontSize: 20, cursor: 'pointer', lineHeight: 1, flexShrink: 0 }}>×</button>
        </div>

        <div style={{ padding: '28px 32px 32px' }}>
          {/* STEP 1 */}
          {step === 1 && (
            <>
              <h3 style={{ margin: '0 0 4px', fontSize: 18, fontWeight: 600, color: '#fff' }}>Start your free trial</h3>
              <p style={{ margin: '0 0 18px', fontSize: 13, color: '#d6dbe1' }}>15 days of the Telegram feed &amp; the FORTE platform.</p>
              <label style={lbl}>How we reach you on Telegram <span style={{ color: '#8b9198', fontWeight: 400 }}>— enter just one, not both</span></label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'end', gap: 10, marginBottom: 8 }}>
                <div>
                  <div style={{ fontSize: 11, color: '#9aa0a8', marginBottom: 4 }}>Telegram username</div>
                  <input style={inp} placeholder="@username" value={form.telegramUsername} onChange={e => setForm({ ...form, telegramUsername: e.target.value })} />
                </div>
                <span style={{ fontSize: 11, color: '#8b9198', fontWeight: 700, letterSpacing: 1, paddingBottom: 11 }}>OR</span>
                <div>
                  <div style={{ fontSize: 11, color: '#9aa0a8', marginBottom: 4 }}>Phone number</div>
                  <input style={inp} type="tel" placeholder="+961 70 123 456" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
                </div>
              </div>
              <div style={{ fontSize: 10.5, color: '#9aa0a8', marginBottom: 12, lineHeight: 1.5 }}>Use whichever your Telegram account is registered with — that's how we match you to the bot.</div>
              <div style={{ marginBottom: 12 }}>
                <label style={lbl}>Name</label><input style={inp} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
              </div>
              <label style={{ ...lbl, marginTop: 6 }}>Countries of interest</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
                {BLOCKS.map(b => {
                  const on = blocks.includes(b.key)
                  return (
                    <div key={b.key} onClick={() => toggleBlock(b.key)} style={{ cursor: 'pointer', border: '1px solid ' + (on ? GOLD : 'rgba(255,255,255,0.12)'), background: on ? 'rgba(194,151,23,0.1)' : 'rgba(255,255,255,0.03)', borderRadius: 7, padding: '11px 13px', display: 'flex', alignItems: 'center', gap: 11 }}>
                      <span style={{ width: 17, height: 17, borderRadius: 4, border: '1px solid ' + (on ? GOLD : 'rgba(255,255,255,0.25)'), background: on ? GOLD : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#111', fontSize: 11, flexShrink: 0 }}>{on ? '✓' : ''}</span>
                      <div>
                        <div style={{ fontSize: 13.5, color: '#f4f4f4', fontWeight: 500 }}>{b.label}</div>
                        {b.sub && <div style={{ fontSize: 10.5, color: '#c4c4c4', marginTop: 1 }}>{b.sub}</div>}
                      </div>
                    </div>
                  )
                })}
              </div>
              {err && <Err msg={err} />}
              <BtnPrimary busy={busy} onClick={submitStep1}>Continue</BtnPrimary>
            </>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <>
              <h3 style={{ margin: '0 0 4px', fontSize: 19, fontWeight: 600, color: '#fff' }}>Add the Telegram bot</h3>
              <p style={{ margin: '0 0 16px', fontSize: 13.5, color: '#d6dbe1' }}>Connect our bot to start receiving live alerts. Pick whichever is easier — both do the same thing.</p>

              {/* OPTION 1 — one tap */}
              <div style={{ border: '1px solid rgba(75,180,245,0.35)', background: 'rgba(75,180,245,0.06)', borderRadius: 10, padding: '15px 16px 16px', marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 11 }}>
                  <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: 0.5, color: '#08121a', background: '#4bb4f5', borderRadius: 20, padding: '3px 10px' }}>OPTION 1</span>
                  <span style={{ fontSize: 12.5, color: '#9fd4f7', fontWeight: 600 }}>Fastest — one tap</span>
                </div>
                <a href="https://t.me/forteintelbot" target="_blank" rel="noopener noreferrer"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9, textDecoration: 'none', background: '#4bb4f5', color: '#08121a', fontWeight: 700, fontSize: 14.5, borderRadius: 8, padding: '13px 16px' }}>
                  <img src="/icons/telegram.png" alt="" style={{ width: 20, height: 20, borderRadius: 4 }} />
                  Open @forteintelbot in Telegram
                </a>
                <div style={{ fontSize: 11.5, color: '#c4c4c4', marginTop: 9, textAlign: 'center', lineHeight: 1.5 }}>Opens the chat — then tap <b style={{ color: '#e6e6e6' }}>Start</b>.</div>
              </div>

              {/* OR divider */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '2px 0 12px' }}>
                <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.1)' }} />
                <span style={{ fontSize: 11, color: '#8b9198', fontWeight: 700, letterSpacing: 1.5 }}>OR</span>
                <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.1)' }} />
              </div>

              {/* OPTION 2 — manual */}
              <div style={{ border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '15px 16px', marginBottom: 18 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 13 }}>
                  <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: 0.5, color: '#e6e6e6', background: 'rgba(255,255,255,0.1)', borderRadius: 20, padding: '3px 10px' }}>OPTION 2</span>
                  <span style={{ fontSize: 12.5, color: '#b6bcc3', fontWeight: 600 }}>Add it manually in Telegram</span>
                </div>
                <div className="ft-step2" style={{ display: 'flex', gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    <StepTag n={1} label="Search @forteintelbot" />
                    <TgSearchMock />
                  </div>
                  <div style={{ flex: 1 }}>
                    <StepTag n={2} label="Open it and tap Start" />
                    <TgChatMock />
                  </div>
                </div>
              </div>
              {form.phone && !form.telegramUsername && (
                <div style={{ fontSize: 11.5, color: '#C29717', background: 'rgba(194,151,23,0.08)', border: '1px solid rgba(194,151,23,0.25)', borderRadius: 6, padding: '9px 12px', marginBottom: 12, lineHeight: 1.5 }}>
                  You signed up with a phone number. When the chat opens, tap <b>“Share my phone number”</b> so we can match you.
                </div>
              )}
              {(checking || checkMsg) && <div style={{ fontSize: 12, color: '#d7dce2', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>{checking && <Spinner />}{checkMsg}</div>}
              {err && <Err msg={err} />}
              <BtnPrimary busy={checking} onClick={checkBot}>I've added the bot</BtnPrimary>
              <button onClick={() => setStep(1)} style={{ background: 'none', border: 'none', color: '#c4c4c4', fontSize: 12, cursor: 'pointer', marginTop: 10, width: '100%' }}>← Back</button>
            </>
          )}

          {/* STEP 3 */}
          {step === 3 && wantAccess !== 'done' && (
            <>
              <div style={{ textAlign: 'center', marginBottom: 8 }}><Check /></div>
              <h3 style={{ margin: '0 0 4px', fontSize: 19, fontWeight: 600, color: '#fff', textAlign: 'center' }}>You're all set on Telegram</h3>
              <p style={{ margin: '0 0 18px', fontSize: 13.5, color: '#d6dbe1', textAlign: 'center' }}>You'll be receiving live alerts in {activeCountries.join(', ')}.</p>
              <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: '16px 18px', marginBottom: 16, textAlign: 'center' }}>
                <div style={{ fontSize: 14.5, color: '#f4f4f4', fontWeight: 500, marginBottom: 4 }}>Would you like to create your access to the FORTE Platform?</div>
                <div style={{ fontSize: 12.5, color: '#d2d2d2' }}>Interactive map, reports and satellite analysis, free for 15 days.</div>
              </div>
              {wantAccess !== 'form' ? (
                <>
                  <BtnPrimary onClick={() => setWantAccess('form')}>Yes, create my access</BtnPrimary>
                  <button onClick={close} style={{ background: 'none', border: 'none', color: '#c4c4c4', fontSize: 12.5, cursor: 'pointer', marginTop: 12, width: '100%' }}>No thanks, just Telegram</button>
                </>
              ) : (
                <>
                  <div style={{ marginBottom: 12 }}>
                    <label style={lbl}>Work email</label>
                    <input style={inp} type="email" placeholder="you@organization.com" value={form.email} autoFocus onChange={e => setForm({ ...form, email: e.target.value })} />
                  </div>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Choose a password</label>
                    <input style={inp} type="password" placeholder="Min. 6 characters" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && createAccess()} />
                  </div>
                  {err && <Err msg={err} />}
                  <BtnPrimary busy={busy} onClick={createAccess}>Create my access</BtnPrimary>
                </>
              )}
            </>
          )}

          {/* DONE — verify email required, no platform entry */}
          {wantAccess === 'done' && (
            <>
              <div style={{ textAlign: 'center', marginBottom: 12 }}>
                <span style={{ display: 'inline-flex', width: 46, height: 46, borderRadius: '50%', background: 'rgba(194,151,23,0.14)', border: '1px solid rgba(194,151,23,0.4)', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="1.6"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
                </span>
              </div>
              <h3 style={{ margin: '0 0 8px', fontSize: 19, fontWeight: 600, color: '#fff', textAlign: 'center' }}>Check your email to get your access</h3>
              <p style={{ margin: '0 0 20px', fontSize: 13.5, color: '#d7dce2', textAlign: 'center', lineHeight: 1.65 }}>
                We've sent a verification link to <b style={{ color: '#f4f4f4' }}>{doneEmail}</b>. Click it to activate your 15-day access, then sign in to the platform.
              </p>
              <BtnPrimary onClick={() => navigate('/login')}>Go to sign in →</BtnPrimary>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

// ---- small UI bits ----
const BtnPrimary = ({ children, onClick, busy }) => (
  <button onClick={onClick} disabled={busy} style={{ width: '100%', background: GOLD, color: '#111', border: 'none', borderRadius: 6, padding: '12px', fontSize: 13.5, fontWeight: 700, cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.6 : 1, letterSpacing: 0.3 }}>{busy ? 'Please wait…' : children}</button>
)
const Err = ({ msg }) => <div style={{ background: 'rgba(229,85,85,0.1)', border: '1px solid rgba(229,85,85,0.3)', color: '#e88', fontSize: 12, borderRadius: 5, padding: '9px 12px', marginBottom: 12 }}>{msg}</div>
const StepTag = ({ n, label }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 9 }}>
    <span style={{ width: 19, height: 19, borderRadius: '50%', background: GOLD, color: '#111', fontSize: 10.5, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{n}</span>
    <span style={{ fontSize: 11.5, color: '#c8c8c8', fontWeight: 500 }}>{label}</span>
  </div>
)
const Spinner = () => <span style={{ width: 13, height: 13, border: '2px solid rgba(194,151,23,0.3)', borderTopColor: GOLD, borderRadius: '50%', display: 'inline-block', animation: 'ftspin 0.7s linear infinite' }} />
const Check = () => <span style={{ display: 'inline-flex', width: 42, height: 42, borderRadius: '50%', background: 'rgba(46,204,113,0.15)', border: '1px solid rgba(46,204,113,0.4)', alignItems: 'center', justifyContent: 'center', color: '#2ecc71', fontSize: 22 }}>✓</span>
const TgGlyph = ({ size = 16 }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="#28a3e8"><path d="M21.9 4.3l-3.3 15.6c-.25 1.1-.9 1.37-1.83.85l-5.05-3.72-2.44 2.35c-.27.27-.5.5-1 .5l.36-5.1L18 5.6c.4-.36-.09-.56-.62-.2L6.4 12.13l-4.98-1.56c-1.08-.34-1.1-1.08.23-1.6L20.5 2.72c.9-.33 1.69.2 1.4 1.58z" /></svg>)

// Telegram search-screen mockup (clean, rounded)
function TgSearchMock() {
  return (
    <div style={{ flex: 1, background: '#17212b', borderRadius: 12, border: '1px solid rgba(255,255,255,0.12)', overflow: 'hidden', boxShadow: '0 6px 20px rgba(0,0,0,0.35)' }}>
      <div style={{ padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 9, color: '#fff', fontSize: 12, fontWeight: 500 }}>
        <span style={{ fontSize: 15 }}>←</span> New Message
      </div>
      <div style={{ padding: '0 10px 10px' }}>
        <div style={{ background: '#242f3d', borderRadius: 8, padding: '7px 10px', display: 'flex', alignItems: 'center', gap: 7 }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6a7c8f" strokeWidth="2"><circle cx="10" cy="10" r="7" /><line x1="15" y1="15" x2="21" y2="21" /></svg>
          <span style={{ color: '#e6ebf0', fontSize: 12 }}>@forteintelbot</span>
          <span style={{ marginLeft: 'auto', color: '#6a7c8f', fontSize: 13 }}>×</span>
        </div>
        <div style={{ fontSize: 9, color: '#6a7c8f', textTransform: 'uppercase', letterSpacing: 0.5, margin: '11px 2px 7px' }}>Global search</div>
        <div style={{ background: '#213040', borderRadius: 8, padding: '8px 9px', display: 'flex', alignItems: 'center', gap: 9 }}>
          <span style={{ width: 30, height: 30, borderRadius: '50%', background: '#2b2b2b', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><img src="/icons/logo.webp" alt="" style={{ width: 18, opacity: 0.85 }} /></span>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#fff', fontWeight: 500 }}>FORTE Intel</div>
            <div style={{ fontSize: 11, color: '#4ea3e0' }}>@forteintelbot</div>
          </div>
        </div>
      </div>
    </div>
  )
}
// Telegram bot-chat mockup with Start button
function TgChatMock() {
  return (
    <div style={{ flex: 1, background: '#0e1621', borderRadius: 12, border: '1px solid rgba(255,255,255,0.12)', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 6px 20px rgba(0,0,0,0.35)', minHeight: 168 }}>
      <div style={{ padding: '9px 11px', background: '#17212b', display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ color: '#fff', fontSize: 14 }}>←</span>
        <span style={{ width: 26, height: 26, borderRadius: '50%', background: '#2b2b2b', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><img src="/icons/logo.webp" alt="" style={{ width: 15, opacity: 0.85 }} /></span>
        <div style={{ lineHeight: 1.2 }}>
          <div style={{ fontSize: 11.5, color: '#fff', fontWeight: 500 }}>FORTE Intel</div>
          <div style={{ fontSize: 9.5, color: '#6a7c8f' }}>bot</div>
        </div>
        <span style={{ marginLeft: 'auto', color: '#6a7c8f' }}>⋮</span>
      </div>
      <div style={{ flex: 1 }} />
      <div style={{ padding: 10 }}>
        <div style={{ background: 'rgba(43,82,120,0.55)', border: '1px solid rgba(78,163,224,0.35)', borderRadius: 8, textAlign: 'center', color: '#e8f2fb', fontSize: 14, fontWeight: 500, padding: '11px' }}>Start</div>
      </div>
    </div>
  )
}

export default withRouter(FreeTrial)
